class GridToolModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.isActive = false;

        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};

        this.ui.$toggler = document.querySelector('.js-grid-toggle');
        this.ui.$markers = document.querySelector('.js-grid-markers');
    }

    bindEvents() {
        this.ui.$toggler.addEventListener('click', this.onClickToggle.bind(this));
    }

    onClickToggle(e) {
        e.preventDefault();

        if (this.isActive) {
            this.isActive = false;

            this.ui.$markers.classList.remove('is-active');
        } else {
            this.isActive = true;

            this.ui.$markers.classList.add('is-active');
        }
    }
};

export default GridToolModule;
